import { Box } from '@mui/material';
import { styled } from '@mui/material/styles';
import { useAppSelector } from 'store';
import { profileSelector } from 'store/selectors/profile-selectors';
import { formatDeviation } from '../utils';
import BooleanIndicatorIcon from './BooleanIndicatorIcon';

interface DeviationCellProps {
  deviationMinutes: number;
}

const DeviationText = styled('span')({
  color: '#FF8C00',
  fontWeight: 600,
  fontSize: '14px',
});

const DeviationCell = (props: DeviationCellProps) => {
  const { deviationMinutes } = props;
  const languageId = useAppSelector(profileSelector)?.languageId;

  if (deviationMinutes === 0) {
    return <BooleanIndicatorIcon value={false} />;
  }

  return (
    <Box display="flex" alignItems="center" justifyContent="center">
      <DeviationText>{formatDeviation(deviationMinutes, languageId)}</DeviationText>
    </Box>
  );
};

export default DeviationCell;
